import { Component, ElementRef, forwardRef, Input, OnInit, ViewChild, Output, EventEmitter, AfterViewInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Utils} from '../../utils/utils';

@Component({
    selector: 'app-image-input',
    templateUrl: './image-input.component.html',
    styleUrls: ['./image-input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ImageInputComponent),
        multi: true
    }]
})
export class ImageInputComponent implements OnInit, ControlValueAccessor, AfterViewInit {

    @ViewChild('imageUploader', { static: false }) elementRef: ElementRef;
    @ViewChild('htmlImageElement') imgElement: ElementRef;


    @Input() resizeTo = 720;
    @Input() name: string;
    @Input() label: string;
    @Input() showClearButton = true;
    @Input() resizeImage = true;

    @Input() imageQuality = 90;

    @Output() inputModelChange = new EventEmitter<string>();

    private focusOutTestingEnabled = true;

    private _inputModel: string;


    get inputModel(): string {
        return this._inputModel;
    }

    set inputModel(value: string) {
        this._inputModel = value;
        this.inputModelChange.emit(value);
    }

    constructor() {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.updateImageSource();
    }


    private onChangeFn: any = () => {
    };
    private onTouchedFn: any = () => {
    };

    public registerOnChange(fn: any): void {
        this.onChangeFn = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    public writeValue(value: string): void {
        this.inputModel = value;
        if (value) {
            this.updateImageSource();
        }
    }

    public async processFile(htmlImageElement: HTMLImageElement, e: Event) {
        const target: any = e.target
        let file: File = target && target.files[0];

        let dataUrl: string | Blob = '';

        if (this.resizeImage) {
            dataUrl = await Utils.resizeImage(file, this.resizeTo, true, this.imageQuality);
        } else {
            dataUrl = await Utils.getImageAsBase64(file);
        }

        htmlImageElement.src = dataUrl.toString();
        this.inputModel = htmlImageElement.src.split(';base64,')[1];
        this.onChangeFn(this.inputModel);
    }

    public disableFocusOutTesting(focusTest: HTMLDivElement) {
        this.focusOutTestingEnabled = false;
        setTimeout((_: any)=>{
            focusTest.focus();
            this.focusOutTestingEnabled = true;
        },300);
    }

    public onFocusOut() {
        setTimeout((_: any)=>{
            if (this.focusOutTestingEnabled) {
                this.onTouchedFn();
            }
        },300);
    }

    onRemoveBtnClicked() {
        this.inputModel = null;
        this.onChangeFn(this.inputModel);

        // Clear the file input value to trigger its change event
        const fileInput = this.elementRef.nativeElement;
        fileInput.value = ''; // Clear the input value
    }

    private updateImageSource() {
        if (this.imgElement?.nativeElement && this._inputModel) {
            let newSrc = 'data:image/jpeg;base64,' + this._inputModel;
            this.imgElement.nativeElement.src = 'data:image/jpeg;base64,' + this._inputModel;
        }
    }
}
